var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-component"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"aria-label":!_vm.rowLabelId ? _vm.id : undefined},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onChange}}),_c('label',{staticClass:"ml-2",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }